import React, { useState, } from 'react';
import UserCopy from '../../../container/pages/UserCopy';
import UserCreate from '../../../container/pages/UserCreate';
import UserManager from '../../../container/pages/UserManager';
import UsageManager from '../../../container/pages/UsageManager';
import TokenManager from '../../../container/pages/TokenManager';

import './AdminMain.css'
import NoiseFilterManager from '../../../container/pages/NoiseFilterManager';

const AdminMain = (props) => {
  const [adminTab, setAdminTab] = useState('ACCOUNTCREATE');

  const AdminFunc = () => {
    return [
      {
        func: 'ACCOUNTCREATE',
      },
      {
        func: 'ACCOUNTMANAGER',
      },
      {
        func: 'ACCOUNTCOPY',
      },
      {
        func: 'NOISEFILTERMANAGER',
      },
      {
        func: 'USAGE',
      },
      {
        func: 'TOKEN',
      },
    ]
  }

  const AdminFuncLabel = ({ adminFunc }) => {
    switch (adminFunc) {
      case 'ACCOUNTCREATE':
        return (<>유저 생성</>)
      case 'ACCOUNTMANAGER':
        return (<>유저 관리</>)
      case 'ACCOUNTCOPY':
        return (<>유저 복사</>)
      case 'NOISEFILTERMANAGER':
        return (<>노이즈필터 관리</>)
      case 'USAGE':
        return (<>사용량 산출</>)
      case 'TOKEN':
        return (<>API 토큰 관리</>)
      default:
        return (<></>);
    }
  }

  const AdminFuncContent = ({ adminFunc }) => {
    switch (adminFunc) {
      case 'ACCOUNTCREATE':
        return (<UserCreate />)
      case 'ACCOUNTMANAGER':
        return (<UserManager />)
      case 'ACCOUNTCOPY':
        return (<UserCopy />)
      case 'NOISEFILTERMANAGER':
        return (<NoiseFilterManager />)
      case 'USAGE':
        return (<UsageManager />)
      case 'TOKEN':
        return (<TokenManager />)
      default:
        return (<></>);
    }
  }

  return (
    <div className="row featured-main">
      <div className="AdminTitle" >
        <span className="nielsen-navyBlack">ADMIN</span>
        <div className="AdminTab">
          {AdminFunc().map((item) => {
            return (
              <>
                <input id={`tab` + item.func} type="radio" name="qrstabs" checked={item.func == adminTab ? true : false} />
                <label id={`tab` + item.func} onClick={() => setAdminTab(item.func)}>
                  <AdminFuncLabel adminFunc={item.func} />
                </label>
              </>
            )
          })}
        </div>
      </div>
      <div className="AdminContent">
        <AdminFuncContent adminFunc={adminTab} />
      </div>
    </div>
  )
}

export default AdminMain;